import React, { useState } from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

const Content = styled.div`
	margin-top: 20px;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 50px;
	${media.lessThan('medium')`
		grid-gap: 20px;
		grid-template-columns: 1fr;
	`}
`;

const Feat = styled.div`
	border: 1px solid ${props => props.theme.green};
	border-radius: 10px;
	display: inline-block;
	text-align: center;
	padding: 20px 30px;
`;

const P = styled.p`
	font-weight: 100;
	font-size: 13px;
	margin-top: 10px;
`;


const Feature = () => {
	const [features] = useState([
		{ id: 1, title: 'Temukan Layanan', content: 'Anda mungkin membutuhkan berbagai layanan yang sesuai dengan kebutuhan, disini Anda bisa mendapatkannya. Dengan fitur untuk memilah layanan berdasarkan kategori yang akan memudahkan Anda' },
		{ id: 2, title: 'Buat Proyek', content: 'Membutuhkan orang dalam pengembangan proyek Anda? Ataupun sedang melakukan pekerjaan yang membutuhkan bantuan? Anda dapat mempostingnya disini sehingga akan banyak orang yang melihat dan menghubungi Anda untuk membantu.' },
		{ id: 3, title: 'Sederhana', content: 'Fitur sederhana yang memudahkan pengguna, dengan beberapa kategori yang akan terus bertambah.' },
	]);

	const feature = features.map(feature => {
		return(
			<Feat key={feature.id} data-aos="fade-up">
				<h3>{feature.title}</h3>
				<P>{feature.content.slice(0, 144)}...</P>
			</Feat>
		);
	});

	return(
		<Content>
			{ feature }
		</Content>
	);
}

export default Feature;